import { render, staticRenderFns } from "./UnsupportedDialog.vue?vue&type=template&id=1fb74838&scoped=true"
import script from "./UnsupportedDialog.vue?vue&type=script&lang=ts"
export * from "./UnsupportedDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb74838",
  null
  
)

export default component.exports